export const environment = {
  production: false,
  env: 'demo',
  apiUrl: 'https://api-demo.caremessenger.co.uk/v2',
  signalingUrl: 'https://signal.bxthree.com',
  pusherKey: '3172982b265ddb84b0ad',
  ravenDsn: 'https://588f3cd1851c4b3e911855c54bc3dc0d@sentry.bxthree.com/44',
};
